<template>
    <b-container fluid class="mt--7">
        <view-item
            v-if="!!item"
            :item="item"
            @success="alertSuccess($event)"
            @delete-item="deleteType"
            @cancel="item = false"
        ></view-item>

        <list-items
            v-else
            title="Customer Request Categories"
            :items="categories"
            @show-item="showItem"
            ref="table"
        >
            <b-row>
                <b-col offset="8" class="text-right">
                    <b-button variant="primary" @click="item = {}"
                        >Add Category</b-button
                    >
                </b-col>
            </b-row>
        </list-items>
    </b-container>
</template>
<script>
import popupMixins from '@/mixins/popupMixins'
import utilityMixins from '@/mixins/utilityMixins'

import ListItems from './ListItems'
import ViewItem from './ViewItem'

export default {
    name: 'RequestCategory',
    components: {
        ListItems,
        ViewItem,
    },
    mixins: [popupMixins, utilityMixins],
    data: () => {
        return {
            item: null,
        }
    },
    mounted() {
        this.doSearch()
    },
    computed: {
        categories() {
            const categories = this.$store.state.requestCategory.categories||[]
            console.log('categories', categories)
            return categories
        },
        user_permissions() {
            return this.$store.getters.user_permissions
        },
    },

    methods: {
        doSearch() {
            this.$store.dispatch('requestCategory/fetchAll')
        },

        showItem(id) {
            this.item = this.categories.find(x => x.id === id)
        },

        alertSuccess(message) {
            this.doToast('Success', message, 'success')
            this.item = null
            this.doSearch()
        },
    },
}
</script>
<style></style>
